import React from "react";
import { IonList, IonItem, IonInput, IonButton, IonIcon } from "@ionic/react";
import { eye, eyeOff } from "ionicons/icons";

const LoginInputControls: React.FC<{
  un: React.RefObject<HTMLIonInputElement>;
  pw: React.RefObject<HTMLIonInputElement>;
  pwType: String;
  togglePwType: () => void;
}> = (props) => {
  return (
    <IonList className="ion-padding is-list-transparent">
      <IonItem>
        <IonInput ref={props.un} type="text" placeholder="Email o nome utente"></IonInput>
      </IonItem>

      <IonItem className="is-password-field">
        <IonInput
          ref={props.pw}
          type={props.pwType === "password" ? "password" : "text"}
          placeholder="Password"
        ></IonInput>
        <IonButton
          fill="clear"
          size="default"
          slot="end"
          onClick={props.togglePwType}
        >
          <IonIcon icon={props.pwType === "password" ? eyeOff : eye}></IonIcon>
        </IonButton>
      </IonItem>
    </IonList>
  );
};

export default LoginInputControls;
